import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router';
import axios from 'axios';
import store from './store'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
import AOS from 'aos'
import 'aos/dist/aos.css'

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import VueElementLoading from 'vue-element-loading' 
// import ServerError from "./components/Common/500.vue"
Vue.component('VueElementLoading', VueElementLoading)
import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);
// Vue.component('ServerError', ServerError)
Vue.config.productionTip = false
window.axios = require('axios')

// Vue.prototype.frontendURL = "http://localhost:8080/"
// axios.defaults.baseURL = 'http://192.168.53.247:3500';
// Vue.prototype.baseURL = "http://192.168.53.247:3500"
// Vue.prototype.mediaURL = "http://192.168.53.247:3500/u/"


axios.defaults.baseURL = 'http://election.leopardtechlabs.in/';
Vue.prototype.baseURL = "http://election.leopardtechlabs.in/"
Vue.prototype.mediaURL = "http://election.leopardtechlabs.in//u/"

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
    mounted() {
        AOS.init()
      },
}).$mount('#app')